// Custom components
import React from "react";

function InputField(props: {
  id: string;
  label: string;
  extra: string;
  placeholder: string;
  variant: string;
  state?: string;
  disabled?: boolean;
  type?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  autoComplete?: string;
}) {
  const {
    label,
    id,
    extra,
    type,
    placeholder,
    variant,
    state,
    disabled,
    value,
    onChange,
    autoComplete,
  } = props;

  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className={`text-sm text-gray-700 ${
          variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
        }`}
      >
        {label}
      </label>
      <input
        disabled={disabled}
        type={type}
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border border-gray-300 bg-white/5 p-3 text-sm text-gray-800 outline-none transition-all duration-200 focus:border-amber-500 focus:ring-2 focus:ring-amber-500/50 ${
          disabled === true
            ? "!border-none !bg-gray-100 placeholder:!text-gray-400"
            : state === "error"
            ? "border-red-500 text-red-500 placeholder:text-red-500 focus:border-red-500 focus:ring-red-500/50"
            : state === "success"
            ? "border-green-500 text-green-500 placeholder:text-green-500 focus:border-green-500 focus:ring-green-500/50"
            : "placeholder:text-gray-400"
        }`}
      />
    </div>
  );
}

export default InputField;
